





















import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import { ManualItem } from "@/components/manual/types";
import ManualList from "@/components/manual/manual.vue";

@Component({
  components: {
    ManualList
  }
})
export default class Guide extends Mixins(AxiosMixin) {
  /** スタートアップガイドリスト */
  private startupManuals: ManualItem[] = [];
  /** マニュアルリスト */
  private manuals: ManualItem[] = [];

  created() {
    this.fetchManuals();
  }

  /** マニュアル取得 */
  private fetchManuals() {
    this.postJsonCheck(window.base_url + "/api/manuals/get", {}, res => {
      this.startupManuals = res.data.startup_manuals;
      this.manuals = res.data.manuals;
    });
  }
}
